module.exports = __webpack_public_path__ + "img/Aura_water.7fb47169.png";